import * as React from 'react';

import { isArrayWithItems } from '../../../utils';
import { RealtyRegions } from '../../../utils/regions_map';

import * as styles from './RoadsMap.css';
import { IHttpApi } from '@cian/http-api/shared';

export enum Regions {
  Moscow = 1,
  Spb,
  Rostov,
}

const SOURCES_MAP = {
  [Regions.Moscow]: 'https://static-maps.yandex.ru/1.x/?lang=ru-RU&ll=37.646965,55.725047&z=7&l=map&size=643,450',
  [Regions.Spb]: 'https://static-maps.yandex.ru/1.x/?lang=ru-RU&ll=31.59,59.8&z=7&l=map&size=643,450',
  [Regions.Rostov]: 'https://static-maps.yandex.ru/1.x/?lang=ru-RU&ll=40.970010,47.652131&z=7&l=map&size=643,450',
};

const ROADS_MAP = {
  [Regions.Moscow]: 'MoscowRoads',
  [Regions.Spb]: 'SpbRoads',
  [Regions.Rostov]: 'RostovRoads',
};

export const getRegionById = (regionId: number) => {
  switch (regionId) {
    case RealtyRegions.Moscow:
    case RealtyRegions.MoscowArea:
    case RealtyRegions.MoscowAndArea:
      return Regions.Moscow;
    case RealtyRegions.StPetersburg:
    case RealtyRegions.StPetersburgArea:
    case RealtyRegions.StPetersburgAndArea:
      return Regions.Spb;
    case RealtyRegions.Rostov:
    case RealtyRegions.RostovArea:
      return Regions.Rostov;
    default:
      return null;
  }
};

export interface IRoadsMapProps {
  hovered: number[];
  regionId: number;
  selectedRoads: number[];
  httpApi: IHttpApi;
}

export interface IRoadsMapState {
  error?: string;
  mapElement: React.LazyExoticComponent<React.ComponentType> | null;
}

export class RoadsMap extends React.Component<IRoadsMapProps, IRoadsMapState> {
  public state: IRoadsMapState = {
    error: '',
    mapElement: null,
  };

  private container = React.createRef<HTMLDivElement>();

  private hoveredRoad: SVGGElement[];

  public async componentDidMount() {
    const { regionId } = this.props;
    const region = getRegionById(regionId);

    if (region) {
      const mapElement = React.lazy(() => import(`./roads/${ROADS_MAP[region]}`));

      this.setState({ mapElement });
    }
  }

  public UNSAFE_componentWillReceiveProps(nextProps: IRoadsMapProps) {
    if (this.props.hovered !== nextProps.hovered || this.props.selectedRoads !== nextProps.selectedRoads) {
      this.changeHovered([...new Set([...nextProps.hovered, ...nextProps.selectedRoads])]);
    }
  }

  public render() {
    const { regionId } = this.props;
    const region = getRegionById(regionId);
    const { mapElement: MapElement } = this.state;

    if (!region || !MapElement) {
      return null;
    }

    return (
      <div ref={this.container} className={styles['container']}>
        <React.Suspense fallback="">
          <MapElement />
        </React.Suspense>
        <img className={styles['map']} src={SOURCES_MAP[region]} />
      </div>
    );
  }

  private getSvgRoad = (id: number) => {
    return this.container.current && this.container.current.querySelector<SVGGElement>(`g[data-road-id="${id}"]`);
  };

  private setHovered = (hovered: boolean) => {
    if (!isArrayWithItems(this.hoveredRoad)) {
      return;
    }
    const svg = this.container.current && this.container.current.querySelector('svg');
    if (hovered && svg) {
      this.hoveredRoad.forEach(el => {
        // Используем setAttribute('class', '...'), т.к. classList в svg не работает в IE11
        el.setAttribute('class', styles['road_hovered']);
        // т.к. у SVG нет z-index, перемещаем элемент в самый конец SVG
        svg.appendChild(el);
      });
    } else {
      this.hoveredRoad.forEach(el => el.removeAttribute('class'));
    }
  };

  private changeHovered = (hovered?: number[]) => {
    const hoveredIds = hovered || this.props.selectedRoads;
    this.setHovered(false);
    this.hoveredRoad = hoveredIds.map(this.getSvgRoad).filter(Boolean) as SVGGElement[];
    this.setHovered(true);
  };
}
